import { HttpClient } from 'core/common/services';
import { Locales, Regions, UserLocation } from 'core/user/entities';
import { LocationService } from './LocationService';

export class LocationServerService implements LocationService {
  private country = '';

  constructor(private readonly httpClient: HttpClient) {}

  getCountry() {
    return this.country;
  }

  readCookieLocation(): UserLocation | null {
    return null;
  }

  async getLocation(ip?: string): Promise<UserLocation> {
    try {
      const { data: location } = await this.httpClient.get<UserLocation>('/locale', {
        params: {
          ip,
        },
      });

      this.setCountry(location.country);

      return {
        locale: location.locale,
        region: location.region,
        country: location.country,
      };
    } catch {
      return {
        locale: Locales.OTHER,
        country: '',
        region: Regions.OTHER,
      };
    }
  }

  private setCountry(country: string) {
    this.country = country;
  }
}
